module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/18b504b8572a14661279856a13522f25.svg";